import { Container } from '@ztechapps/webui.contract'

export function setupContainer() {
  const container = new Container()

  // OwnText Admin doesn't need complex route bindings for now
  // Add module containers here as needed

  return container
}
